"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminSoftwareApi = exports.AdminSoftwareApiFactory = exports.AdminSoftwareApiFp = exports.AdminSoftwareApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AdminSoftwareApi - axios parameter creator
 * @export
 */
exports.AdminSoftwareApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Clone softwares from tenant
         * @param {string} [tenantId] tenantId
         * @param {InputCloneSoftwaresFromTenant} [inputCloneSoftwaresFromTenant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneSoftwaresFromTenant: (tenantId, inputCloneSoftwaresFromTenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/software/clone/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputCloneSoftwaresFromTenant, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create software
         * @param {string} [tenantId] tenantId
         * @param {EditCreateSoftware} [editCreateSoftware]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSoftware: (tenantId, editCreateSoftware, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/software/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editCreateSoftware, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete software
         * @param {string} softwareId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftware: (softwareId, tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'softwareId' is not null or undefined
            common_1.assertParamExists('deleteSoftware', 'softwareId', softwareId);
            const localVarPath = `/admin/software/{softwareId}/`
                .replace(`{${"softwareId"}}`, encodeURIComponent(String(softwareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Edit software
         * @param {string} softwareId
         * @param {string} [tenantId] tenantId
         * @param {EditCreateSoftware} [editCreateSoftware]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftware: (softwareId, tenantId, editCreateSoftware, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'softwareId' is not null or undefined
            common_1.assertParamExists('editSoftware', 'softwareId', softwareId);
            const localVarPath = `/admin/software/{softwareId}/`
                .replace(`{${"softwareId"}}`, encodeURIComponent(String(softwareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editCreateSoftware, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"update\", \"Software\"]
         * @summary Edit software image | Permission required: [\"update\", \"Software\"]
         * @param {string} softwareId
         * @param {any} file
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftwareImage: (softwareId, file, tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'softwareId' is not null or undefined
            common_1.assertParamExists('editSoftwareImage', 'softwareId', softwareId);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('editSoftwareImage', 'file', file);
            const localVarPath = `/admin/software/{softwareId}/image/`
                .replace(`{${"softwareId"}}`, encodeURIComponent(String(softwareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"readAll\", \"Software\"]
         * @summary Get admin softwares | Permission required: [\"readAll\", \"Software\"]
         * @param {string} [tenantId] tenantId
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSoftwares: (tenantId, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/software/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminSoftwareApi - functional programming interface
 * @export
 */
exports.AdminSoftwareApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdminSoftwareApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Clone softwares from tenant
         * @param {string} [tenantId] tenantId
         * @param {InputCloneSoftwaresFromTenant} [inputCloneSoftwaresFromTenant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneSoftwaresFromTenant(tenantId, inputCloneSoftwaresFromTenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneSoftwaresFromTenant(tenantId, inputCloneSoftwaresFromTenant, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create software
         * @param {string} [tenantId] tenantId
         * @param {EditCreateSoftware} [editCreateSoftware]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSoftware(tenantId, editCreateSoftware, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSoftware(tenantId, editCreateSoftware, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete software
         * @param {string} softwareId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftware(softwareId, tenantId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSoftware(softwareId, tenantId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Edit software
         * @param {string} softwareId
         * @param {string} [tenantId] tenantId
         * @param {EditCreateSoftware} [editCreateSoftware]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftware(softwareId, tenantId, editCreateSoftware, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editSoftware(softwareId, tenantId, editCreateSoftware, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"update\", \"Software\"]
         * @summary Edit software image | Permission required: [\"update\", \"Software\"]
         * @param {string} softwareId
         * @param {any} file
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftwareImage(softwareId, file, tenantId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editSoftwareImage(softwareId, file, tenantId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"readAll\", \"Software\"]
         * @summary Get admin softwares | Permission required: [\"readAll\", \"Software\"]
         * @param {string} [tenantId] tenantId
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSoftwares(tenantId, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdminSoftwares(tenantId, filter, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminSoftwareApi - factory interface
 * @export
 */
exports.AdminSoftwareApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdminSoftwareApiFp(configuration);
    return {
        /**
         *
         * @summary Clone softwares from tenant
         * @param {string} [tenantId] tenantId
         * @param {InputCloneSoftwaresFromTenant} [inputCloneSoftwaresFromTenant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneSoftwaresFromTenant(tenantId, inputCloneSoftwaresFromTenant, options) {
            return localVarFp.cloneSoftwaresFromTenant(tenantId, inputCloneSoftwaresFromTenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create software
         * @param {string} [tenantId] tenantId
         * @param {EditCreateSoftware} [editCreateSoftware]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSoftware(tenantId, editCreateSoftware, options) {
            return localVarFp.createSoftware(tenantId, editCreateSoftware, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete software
         * @param {string} softwareId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftware(softwareId, tenantId, options) {
            return localVarFp.deleteSoftware(softwareId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit software
         * @param {string} softwareId
         * @param {string} [tenantId] tenantId
         * @param {EditCreateSoftware} [editCreateSoftware]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftware(softwareId, tenantId, editCreateSoftware, options) {
            return localVarFp.editSoftware(softwareId, tenantId, editCreateSoftware, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Software\"]
         * @summary Edit software image | Permission required: [\"update\", \"Software\"]
         * @param {string} softwareId
         * @param {any} file
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftwareImage(softwareId, file, tenantId, options) {
            return localVarFp.editSoftwareImage(softwareId, file, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"Software\"]
         * @summary Get admin softwares | Permission required: [\"readAll\", \"Software\"]
         * @param {string} [tenantId] tenantId
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSoftwares(tenantId, filter, options) {
            return localVarFp.getAdminSoftwares(tenantId, filter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminSoftwareApi - object-oriented interface
 * @export
 * @class AdminSoftwareApi
 * @extends {BaseAPI}
 */
class AdminSoftwareApi extends base_1.BaseAPI {
    /**
     *
     * @summary Clone softwares from tenant
     * @param {string} [tenantId] tenantId
     * @param {InputCloneSoftwaresFromTenant} [inputCloneSoftwaresFromTenant]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSoftwareApi
     */
    cloneSoftwaresFromTenant(tenantId, inputCloneSoftwaresFromTenant, options) {
        return exports.AdminSoftwareApiFp(this.configuration).cloneSoftwaresFromTenant(tenantId, inputCloneSoftwaresFromTenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create software
     * @param {string} [tenantId] tenantId
     * @param {EditCreateSoftware} [editCreateSoftware]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSoftwareApi
     */
    createSoftware(tenantId, editCreateSoftware, options) {
        return exports.AdminSoftwareApiFp(this.configuration).createSoftware(tenantId, editCreateSoftware, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete software
     * @param {string} softwareId
     * @param {string} [tenantId] tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSoftwareApi
     */
    deleteSoftware(softwareId, tenantId, options) {
        return exports.AdminSoftwareApiFp(this.configuration).deleteSoftware(softwareId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Edit software
     * @param {string} softwareId
     * @param {string} [tenantId] tenantId
     * @param {EditCreateSoftware} [editCreateSoftware]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSoftwareApi
     */
    editSoftware(softwareId, tenantId, editCreateSoftware, options) {
        return exports.AdminSoftwareApiFp(this.configuration).editSoftware(softwareId, tenantId, editCreateSoftware, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"update\", \"Software\"]
     * @summary Edit software image | Permission required: [\"update\", \"Software\"]
     * @param {string} softwareId
     * @param {any} file
     * @param {string} [tenantId] tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSoftwareApi
     */
    editSoftwareImage(softwareId, file, tenantId, options) {
        return exports.AdminSoftwareApiFp(this.configuration).editSoftwareImage(softwareId, file, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"readAll\", \"Software\"]
     * @summary Get admin softwares | Permission required: [\"readAll\", \"Software\"]
     * @param {string} [tenantId] tenantId
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSoftwareApi
     */
    getAdminSoftwares(tenantId, filter, options) {
        return exports.AdminSoftwareApiFp(this.configuration).getAdminSoftwares(tenantId, filter, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminSoftwareApi = AdminSoftwareApi;
